import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

import Chip from 'Chip';

import Tabs, { TabsPane } from './tabs';

import Home from './home';

import AreaFestival from './areaFestival';

import GourmetsFestival from './gourmetsFestival';

import RankList from './rankingList';

import HualianBeer from './hualianBeer';

import GoHome from '../../components/goHome';

import { Alert } from '../../components/modal';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        current: (this.props.content.tabs && this.props.content.tabs[0].title) || '首页',
    };

    handleTabChange = current => {
        const {
            content: { onlineArea },
        } = this.props;

        if (
            onlineArea.filter(i => i.title === current).length &&
            onlineArea.filter(i => i.title === current)[0].online === true
        ) {
            this.setState({ current });
        } else {
            if (current !== '首页') {
                Alert.show({
                    content: (
                        <Fragment>
                            <div className={styles.alerttitleBox}>
                                <div className={styles.alerttitle}>
                                    {(onlineArea.filter(i => i.title === current)[0] &&
                                        onlineArea.filter(i => i.title === current)[0].msg) ||
                                        '尚未开启'}
                                </div>
                            </div>
                            <div className={styles.alertcontent}>敬请期待</div>
                        </Fragment>
                    ),
                });
            }

            this.setState({ current: '首页' });
        }
    };

    render() {
        const {
            onlineArea,
            tabs,
            information,
            homeAd,
            meishiMap,
            thanksFor,
            rule,
            judgesByArea,
            judges,
            manOfTheYear,
            rankingNav,
            rankingList,
            newsData,
            posters,
        } = this.props.content;
        const { current } = this.state;
        /**
         * 组件分发数据
         */
        const areas = ['江浙', '广东', '川渝', '上海'];

        return (
            <div className={styles.content}>
                <Tabs content={tabs} current={current} handleChange={this.handleTabChange}>
                    {tabs.map(item => {
                        if (item.title === '首页') {
                            return (
                                <TabsPane key={item.title}>
                                    <Home
                                        content={{ information, homeAd, meishiMap, thanksFor }}
                                        handleTabChange={this.handleTabChange}
                                    />
                                </TabsPane>
                            );
                        } else if (areas.includes(item.title)) {
                            return (
                                <TabsPane key={item.title}>
                                    <AreaFestival
                                        curArea={current}
                                        content={{
                                            rule,
                                            judgesByArea,
                                            newsData: newsData[item.title],
                                            posters: posters[item.title],
                                            showNews:
                                                onlineArea.filter(i => i.title === current).length &&
                                                onlineArea.filter(i => i.title === current)[0].showNews,
                                        }}
                                    />
                                </TabsPane>
                            );
                        } else if (item.title === '美食盛典') {
                            return (
                                <TabsPane key={item.title}>
                                    <GourmetsFestival
                                        curArea={current}
                                        content={{
                                            rule,
                                            judges: judgesByArea[4] || judges,
                                            manOfTheYear,
                                            newsData: newsData[item.title],
                                            posters: posters[item.title],
                                            showNews:
                                                onlineArea.filter(i => i.title === '美食盛典').length &&
                                                onlineArea.filter(i => i.title === '美食盛典')[0].showNews,
                                        }}
                                    />
                                </TabsPane>
                            );
                        } else if (item.title === '美食榜单') {
                            return (
                                <TabsPane key={item.title}>
                                    <RankList content={{ rankingNav, rankingList, onlineArea }} />
                                </TabsPane>
                            );
                        } else if (item.title === '花脸啤酒') {
                            return (
                                <TabsPane key={item.title}>
                                    <HualianBeer
                                        content={{ newsData: newsData['花脸啤酒'], posters: posters['花脸啤酒'] }}
                                    />
                                </TabsPane>
                            );
                        } else {
                            return null;
                        }
                    })}
                </Tabs>
                {!['首页', '美食榜单'].includes(current) && (
                    <GoHome styles={{ marginTop: 50 }} onClick={() => this.handleTabChange('首页')} />
                )}
            </div>
        );
    }
}

export default errorBoundary(Content);
